import { ButtonGroup as BtnGrp, ButtonGroupProps } from './ButtonGroup';
import { GroupButtonSizes, GROUP_BUTTON_SIZES } from './constants';

/**
 * @deprecated - Use ButtonGroup from ui/buttonGroupV2.
 */
export const ButtonGroup = BtnGrp;
export const SmallButtonGroup = (props: ButtonGroupProps) => (
  <BtnGrp buttonSize={GROUP_BUTTON_SIZES.SMALL as GroupButtonSizes} {...props} />
);
export const MediumButtonGroup = (props: ButtonGroupProps) => (
  <BtnGrp buttonSize={GROUP_BUTTON_SIZES.MEDIUM as GroupButtonSizes} {...props} />
);
export const LargeButtonGroup = (props: ButtonGroupProps) => (
  <BtnGrp buttonSize={GROUP_BUTTON_SIZES.LARGE as GroupButtonSizes} {...props} />
);
/**
 * @deprecated - Use ButtonGroup from ui/buttonGroupV2.
 */
export { GroupButton } from './GroupButton';
export { GROUP_BUTTON_SIZES } from './constants';
